import { useState } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { List } from '@mui/material';

// project imports
import HeaderMenuItem from 'components/HeaderMenuItem';
import RoleFlagGuard from 'utils/route-guard/RoleFlagGuard';

import { BILLING_PAYMENTS_PATH, MY_ACCOUNT_PATH, PRICING_PATH } from 'constants/routeConstants';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import { DollarOutlined, WalletOutlined } from '@ant-design/icons';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

type Props = Readonly<{
  handleLogout: () => void;
}>;

export default function ProfileTab({ handleLogout }: Props) {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleListItemClick = (_: React.MouseEvent<HTMLDivElement>, index: number, route: string = '') => {
    setSelectedIndex(index);
    if (route && route !== '') {
      navigate(route);
    }
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <HeaderMenuItem
        icon={<UserOutlined />}
        onClick={(e) => handleListItemClick(e, 1, MY_ACCOUNT_PATH)}
        selected={selectedIndex === 1}
        titleId="profile"
      />
      <RoleFlagGuard shouldNavigate={false} requiredUserRoles={['ADMIN']}>
        <HeaderMenuItem
          icon={<WalletOutlined />}
          onClick={(e) => handleListItemClick(e, 2, BILLING_PAYMENTS_PATH)}
          selected={selectedIndex === 2}
          titleId="billing"
        />
      </RoleFlagGuard>
      <RoleFlagGuard shouldNavigate={false} requiredUserRoles={['ADMIN']}>
        <HeaderMenuItem
          icon={<DollarOutlined />}
          selected={selectedIndex === 3}
          onClick={(e) => handleListItemClick(e, 3, PRICING_PATH)}
          titleId="plans"
        />
      </RoleFlagGuard>
      <HeaderMenuItem
        icon={<LogoutOutlined />}
        selected={selectedIndex === 4}
        onClick={() => handleLogout()}
        titleId="log-out"
        sx={{ borderTop: 1, borderColor: 'divider' }}
      />
    </List>
  );
}
